import { OpenPresetModalDefinition } from "@modules/+new/shared/universal-modal/entities/modal-definition.interface";
import { PendingData } from "@modules/+new/shared/universal-modal/components/_presets/pending-preset/entities/pending-data";
import { ModalSizes } from "@modules/+new/shared/universal-modal/entities/modal-size.enum";
import { PresetsComponentsEnum } from "@modules/+new/shared/universal-modal/entities/presets-components.enum";
import { EmailMismatchPresetComponent } from "@modules/+new/shared/universal-modal/components/_presets/email-mismatch-preset/email-mismatch-preset.component";

export const EmailMismatchPresetDefinition: OpenPresetModalDefinition<PendingData> = {
	component: EmailMismatchPresetComponent,
	options: {
		wrap: false,
		size: ModalSizes.lg,
		showCancel: false,
		showPrevious: false,
		cancelKey: "close",
		isPreset: PresetsComponentsEnum.emailMismatch
	}
};
